import React from 'react';
import { MessagesSquare, Plus } from 'lucide-react';

interface ActivityEmptyStateProps {
  type: 'activities' | 'tasks' | 'notes';
  message?: string;
  className?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const ActivityEmptyState = React.memo<ActivityEmptyStateProps>(({
  type,
  message,
  className = '',
  actionLabel,
  onAction,
}) => {
  const getDefaultMessage = () => {
    switch (type) {
      case 'activities': return 'No activities yet';
      case 'tasks': return 'No tasks yet';
      case 'notes': return 'No notes yet';
      default: return 'No data found';
    }
  };

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 20px',
        textAlign: 'center',
        minHeight: '200px',
      }}
    >
      <MessagesSquare
        size={48}
        strokeWidth={1.2}
        style={{ color: '#d1d5db', marginBottom: '12px' }}
      />
      <p
        style={{
          color: '#9ca3af',
          fontSize: '14px',
          fontFamily: '"Gilroy-Medium", "Gilroy", sans-serif',
          margin: '0 0 16px 0',
        }}
      >
        {message || getDefaultMessage()}
      </p>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            padding: '8px 16px',
            fontSize: '13px',
            fontFamily: '"Gilroy-Medium", "Gilroy", sans-serif',
            fontWeight: 600,
            color: '#fff',
            backgroundColor: '#3faefd',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#2196f3'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#3faefd'; }}
        >
          <Plus size={16} />
          {actionLabel}
        </button>
      )}
    </div>
  );
});

ActivityEmptyState.displayName = 'ActivityEmptyState';

export default ActivityEmptyState;
